import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { JobPosition } from "../Model/JobPosition";

export async function patchJobPosition(id, data) {
	let response = await getAPIResponse("/v1/jobPosition/" + id, data, "PATCH");
	if (response === null) {
		return null;
	}
	return JobPosition.createFromResponseData(response);
}
